import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import history from '../../../other/history';
import { questionLike, questionUnlike, questionEdit, repliesFetch, showLoginModal, linkPreviewFetch, completeLinkPreviewReset } from '../../../actions/index';
import { translate } from 'react-i18next';
import { gtmSend, esCape } from '../../../helpers';
// import style from './style.css';
import VideoCardComponent from '../../../components/Elems/VideoCard';
import ReplySortDropdown from '../../../components/Elems/ReplySortDropdown';
// import { ProfileThumb } from '../../../components/Common/CardComponents';
import ReplyCardContainer from '../ReplyCard';
import ReplyInputContainer from '../ReplyInput';
import GenericInputModal from '../../../components/Common/CardComponents/GenericInputModal';
import ShareModal from '../../../components/Common/CardComponents/Share';
import EmptyPlaceholder from '../../../components/Misc/EmptyPlaceholder';
import { buildMapping } from '../../../other/ActionMapper';
import { myIsSet } from '../../../helpers';
import { Icon } from '../../../components/Common/Icon';
import cx from '../../../styles';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
import Filters from '../../../other/filters';

class VideoElemContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            replyPage: myIsSet(this.props, 'serverReqQuery.page') ? this.props.serverReqQuery.page : (Number(getUrlParameter('page')) || 1),
            ifShowVideo: false,
            isEditModalOpen: false,
            isShareModalOpen: false,
            editTitle: '',
            editContent: '',
            isLoading: false,
            selectedSort: myIsSet(this.props, 'data.reply_sorting') ? this.props.data.reply_sorting.filter((opt) => {if(opt.selected) return true; else return false;})[0].label : '',
            modalImagePreviews: [],
            modalImages: [],
        };
    }

    componentDidMount() {
        this.replyInput = this.refs.replyInput.getWrappedInstance().getWrappedInstance();//coz of translate hoc
        //
        if (history.location.state && 'shouldOpenQEditDialog' in history.location.state) {
            if (history.location.state.shouldOpenQEditDialog) {
                this.openEditModal();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        //for edit reset
        if (this.props.postReducer.id && nextProps.postReducer.data.topic) {
            if (nextProps.postReducer.data.topic.message != this.props.postReducer.data.topic.message) {
                this.setState({
                    editTitle: nextProps.postReducer.data.topic.title,
                    editContent: nextProps.postReducer.data.topic.message
                });
            }
        }
    }

    goToSingleView = (state = null) => {
        gtmSend('dynamic', 'Video Card', 'click-title-click', this.props.match.path);
        history.push({
            pathname: `/q/${this.props.data.topic.slug}/${this.props.id}`,
            ...(state && { state })
        });
    }

    onReplyClick = () => {
        gtmSend('dynamic', 'Video Card', 'click-reply', this.props.match.path);
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `reply | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `reply | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            this.props.inFeed
                ? this.goToSingleView()
                : this.replyInput.openReplyModal();
        }
    }

    onLikeClick = () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `like | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `like | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else if(!this.state.isLoading) {
            const { index, inFeed, id, data } = this.props;
            gtmSend('dynamic', 'Video Card', `click:${(data.likes.liked ? 'unlike' : 'like')}`, this.props.match.path);
            if(data.likes.liked){
                this.setState({isLoading: true});
                this.props.questionUnlike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
            else{
                this.setState({isLoading: true});
                this.props.questionLike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            } 
        }
    }

    openEditModal = () => {
        this.setState({ isEditModalOpen: true });
    }

    closeEditModal = () => {
        this.setState({ isEditModalOpen: false });
    }

    onEditModalOpen = () => {
        this.setState({
            editTitle: this.props.data.topic.title,
            editContent: this.props.data.topic.message
        });
        //link parsing
        if(this.props.data.video && this.props.data.video.url){
            if(this.props.data.video.url != this.props.composeReducer.linkPreview.url){
                this.props.linkPreviewFetch(this.props.data.video.url);
            }
        }
        //dialog fix
        const state = {};
        history.replace({ ...history.location, state });
    }

    onEditModalSubmit = (e) => {
        e.preventDefault();
        const title = esCape(this.state.editTitle),
            message = esCape(this.state.editContent);
        if(message.length < 10) return this._addNotificationToModal(this.props.t('char_limit_desc'), 'error');
        if(title.length < 10) return this._addNotificationToModal(this.props.t('char_limit_title'), 'error');
        // let anonymous = e.target.anonymous.value;
        // let isActive = 1;
        const questionId = this.props.id,
            linkData = this.props.composeReducer.linkPreview.url ? this.props.composeReducer.linkPreview.linkData : null,
            gifId = e.target.gifId? e.target.gifId.value : '';

        let images = [];
        
        if(this.state.modalImages.length) images = this.state.modalImages.map((image) => {return {image}});
            
        gtmSend('dynamic', 'Video Card Edit', 'click-submit', `submit:${questionId}`);
        this.props.questionEdit(questionId, message, title, 0, images, linkData, gifId, linkData && linkData.type ? `video` : linkData && 'article')
            .then(() => {
                if(!this.props.postReducer.error){
                    this.closeEditModal();
                }else {
                    this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                }
            });
    }

    share = () => {
        gtmSend('dynamic', 'Video Card', 'click-share', this.props.match.path);
        this.setState({ isShareModalOpen: true });
    }

    onRepliesFetch = () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `read more replies | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `read more replies | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        }
        else{
            if (this.props.singleReplyMode) {
                this.goToSingleView();
                // window.location.reload(true);
            } else {
                const page = this.state.replyPage;
                this.props.repliesFetch(this.props.id, Number(page) + 1, this.state.selectedSort)
                .then(() => {
                    if(this.props.userReducer.id){
                        this.setState({
                            replyPage: Number(page) + 1
                        });
                    }
                });
            }
        }
    }

    changeReplySorting = (value) => {
        this.setState({
            replyPage: (Number(getUrlParameter('page')) || 1),
            selectedSort: value
        });
    }

    onPlayHandler = () => {
        gtmSend('dynamic', 'Video Card', 'click-play', this.props.match.path);
        this.setState({ ifShowVideo: true });
    }

    onHashClick = (hashtag) => {
        let editContent = this.state.editContent;
        editContent += ` ${hashtag}`;
        this.setState({editContent});
        document.getElementById("content").focus();
    }

    onLinkPreviewRemove = () => {
        gtmSend('dynamic', 'Article Card Edit', 'click-remove-link-preview', '');
        this.props.completeLinkPreviewReset();
    }

    onEditModalImageUpload = (e) => {
        if (e.target.files.length) {
            gtmSend('dynamic', 'Question Card Edit', 'click-image-upload', '');
            for (let k = 0; k < e.target.files.length; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, base64Result],
                        modalImages: [...this.state.modalImages, base64Result.split(',')[1]]
                    });
                };
            }
        }
    }

    onPreviewImageRemove = (index) => {
        gtmSend('dynamic', 'Question Card Edit', 'click-remove-image-preview', '');
        this.setState({
            modalImagePreviews: [...this.state.modalImagePreviews.slice(0, index), ...this.state.modalImagePreviews.slice(index + 1)],
            modalImages: [...this.state.modalImages.slice(0, index), ...this.state.modalImages.slice(index + 1)]
        });
    }

    render() {
        const {data, index, inFeed, id, t, configReducer, appReducer, postReducer, userReducer, match, singleReplyMode, status} = this.props,
            question = Filters.process(['feedhashtagify'], data.topic.message),
            video = data.video,
            title = data.topic.title,
            slug = data.topic.slug,
            images = data.topic.images,
            topic = data.topic.group,
            author = data.topic.user,
            lastSeen = data.topic.nice_time,
            replies = data.replies,
            // ads = configReducer.ads,
            dfp = configReducer.dfp,
            reply_count = data.topic.reply_count,
            responseBar = {
                replyCount: reply_count,
                likes: data.likes,
                onLikeClick: this.onLikeClick,
                onReplyClick: this.onReplyClick,
                onShareClick: this.share
            },
            actions = buildMapping(
                'question',
                data.actions,
                {
                    id,
                    authorId: author.id,
                    authorName: author.fullname,
                    hideUrl: data.hide_url,
                    position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0),
                    adminUrl: data.backend_url ? data.backend_url : '',
                    subType: this.props.subType,
                    detailPage: this.props.detailPage,
                    elemRef: this,
                    inFeed,
                    t
                },
                this.context.store.dispatch
            );

        return (
            <div className={cx("question-elem-containers", inFeed ? "in-feed-design" : "detail-design")}>

                <div className={cx("main-elem-section")}>
                    <VideoCardComponent index={index}
                        question={Filters.process(['linkify'], question)}
                        title={title}
                        video={video}
                        images={images}
                        topic={topic}
                        id={id}
                        author={author}
                        lastSeen={lastSeen}
                        actions={actions}
                        responseBar={responseBar}
                        ifShowVideo={this.state.ifShowVideo}
                        onPlayHandler={this.onPlayHandler}
                        viewUrl={`q/${slug}/${id}`}
                        inFeed={inFeed}
                        siteUrl={configReducer.siteUrl}
                        onTitleClick={this.goToSingleView}
                        appReducer={appReducer}
                        match={match}
                        status={status}
                        botIndex={data.topic.bot_index}
                        cardName='Video Card'
                    />
                </div>
                
                {/*
                    !inFeed && ads.networkId &&
                    <div className={cx("only-mobile", "ad-wrap")}>
                        {
                            mobileCheck() && 
                            <AdCoreSlot networkId={ads.networkId} 
                                adUnit={ads.mobile.top.unit}
                                styleClass={ads.mobile.top.styleClass}
                                size={[ads.mobile.top.w, ads.mobile.top.h]}
                                id={ads.mobile.top.id} />
                        }
                    </div>
                */}

                {
                    !(postReducer.data && postReducer.data.topic && postReducer.data.topic.nsfw === 1) &&
                    !inFeed && dfp.networkId && myIsSet(dfp, 'ros.banners.side_1.id') &&
                    <div className={cx("only-mobile", "ad-wrap", "shadow-card")}>
                        <AdCoreSlot 
                            dfpKeys={['ros','banners','side_1']}
                            adObj={dfp.ros.banners.side_1}
                            device="mobile"
                            customClass="showAddText"
                            styleClass={dfp.ros.banners.side_1.styleClass} 
                            id={dfp.ros.banners.side_1.id}
                            app={appReducer}
                        />
                    </div>
                }

                <div className={cx("reply-list-wrap")}>
                    {
                        !inFeed && replies.length != 0 &&
                        <ReplySortDropdown
                            t={t}
                            cardName='Video Card'
                            topic={topic}
                            replyCount={responseBar.replyCount}
                            reply_sorting={data.reply_sorting}
                            changeReplySorting={this.changeReplySorting}
                            selectedSort={this.state.selectedSort}
                            id={this.props.id}
                            repliesFetch={this.props.repliesFetch}
                        />
                    }

                    {
                        !inFeed &&
                        <div className={cx('shadow-card')}>
                            <ReplyInputContainer inFeed={inFeed}
                                id={id}
                                slug={slug}
                                ref='replyInput'
                                match={this.props.match}
                                cardName='Video Card' />
                        </div>
                    }

                    {
                        replies.map((reply, i) => {
                            return <ReplyCardContainer key={i}
                                postId={id}
                                slug={slug}
                                cardIndex={index}
                                replyIndex={i}
                                reply={reply}
                                inFeed={inFeed}
                                singleReplyMode={singleReplyMode}
                                match={match}
                                status={status} 
                                topic={topic} />;
                        })
                    }

                    {
                        inFeed
                            ?
                            false && !!data.replies.length &&
                            <div className={cx("more-reply-link", "in-feed")}>
                                {
                                    data.more_reply_count == 0
                                    ?
                                        <span onClick={this.goToSingleView}>
                                            {`${data.more_reply_count} ${data.more_reply_count > 1 ? t('detail_reply_count_plural') : t('detail_reply_count')}`}
                                        </span>
                                    :
                                        ""
                                }

                                {!!data.more_reply_count && <Icon name="right-double-arrow-regular-gray-md" />}
                            </div>
                            :
                            !!data.more_reply_count &&
                            <div className={cx("more-reply-link")}>
                                <a href={`${this.props.match.url}?page=${Number(this.state.replyPage) + 1}`} className={cx("btn", "btn-primary")} onClick={(e) => { e.preventDefault(); this.onRepliesFetch(); }}>
                                    <span>{`${data.more_reply_count} ${data.more_reply_count > 1 ? t('detail_reply_count_plural') : t('detail_reply_count')}`}</span>

                                    <Icon name="down-double-arrow-regular-white-md" />

                                    { postReducer.isLoading && !appReducer.showLoginModal && <span className={cx("spin-loader")} /> }
                                </a>
                            </div>
                    }
                </div>

                {
                    inFeed &&
                    <ReplyInputContainer inFeed={inFeed}
                        id={id}
                        slug={slug}
                        ref='replyInput'
                        match={match}
                        cardName='Video Card' />
                }

                {
                    !(inFeed || data.replies.length) &&
                    <EmptyPlaceholder content={t('detail_empty_response_placeholder')} />
                }

                {
                    !inFeed &&
                    <GenericInputModal isModalOpen={this.state.isEditModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onEditModalOpen,
                            onModalClose: () => this.setState({ isEditModalOpen: false }),
                            onSubmit: this.onEditModalSubmit,
                            onImageUpload: this.onEditModalImageUpload,
                            onPreviewImageRemove: this.onPreviewImageRemove,
                            onContentChange: v => this.setState({ editContent: v }),
                            onHashClick: this.onHashClick,
                            onLinkPreviewRemove: this.onLinkPreviewRemove,
                            onTitleChange: v => this.setState({ editTitle: v }),
                            refAddNotification: (f) => this._addNotificationToModal = f,
                            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f
                        }}
                        gtmLabel={'Video Card Edit'} 
                        title={this.state.editTitle}
                        content={this.state.editContent}
                        imagePreviews={this.state.modalImagePreviews}
                        user={userReducer}
                        showUploadInput={true}
                        showUploadGif={true}
                        showUploadEmbed={true}
                        showNSFW={true}
                        showHash={true}
                        ifEditing={true}
                        topic={topic}
                        linkPreview={this.props.composeReducer.linkPreview}
                        buttonLabel={t('add_edit_save')} />
                }

                {
                    <ShareModal isModalOpen={this.state.isShareModalOpen}
                        position={typeof document != 'undefined' ? document.documentElement.scrollTop : 0}
                        shareType='question'
                        cardName='Video Card'
                        id={id}
                        siteUrl={configReducer.siteUrl}
                        slug={`q/${slug}/${id}`}
                        username={userReducer.full_name}
                        topic={topic}
                        t={t}
                        onModalClose={() => this.setState({ isShareModalOpen: false })} />
                }

            </div>
        );
    }

}

VideoElemContainer.contextTypes = {
    store: PropTypes.object.isRequired
};

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionLike,
        questionUnlike,
        questionEdit,
        repliesFetch,
        showLoginModal,
        linkPreviewFetch,
        completeLinkPreviewReset
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(VideoElemContainer));
